import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { useQuery } from '@tanstack/react-query';
import type { PolicyResponse } from '@http/queries/useCreatePolicy';

export type { PolicyResponse } from '@http/queries/useCreatePolicy';

/** A single custom policy by id (`GET /policies?id=…`). */
export function useFetchPolicy(id: number | null) {
  return useQuery({
    queryKey: [api.policies, id],
    queryFn: () => fetchWrapper.get<PolicyResponse>(api.policies, { id }),
    enabled: id !== null && Number.isInteger(id) && id > 0,
    // Always refetch on mount so the edit form opens with the latest data.
    refetchOnMount: 'always',
  });
}
